import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';

@Component({
  selector: 'app-delete-item-dialog',
  templateUrl: './delete-item-dialog.component.html',
  styleUrls: ['./delete-item-dialog.component.css']
})
export class DeleteItemDialogComponent {
  deleteItemForm: FormGroup;
  constructor(public dialogRef: MdDialogRef<DeleteItemDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder) {
    this.createForm();
  }
  /**
   * Creates the delete confirmation form
   */
  createForm() {
    this.deleteItemForm = this.formBuilder.group({
      name: ['', [
        Validators.required,
        //
        this.deleteConfirmationValidator(this.data.name)
      ]]
    });
  }
  /**
   * Closes the form and returns the ID of the item to be deleted
   */
  onSubmit() {
    this.dialogRef.close(this.data.id);
  }
  /**
   * Tests whether or not the value of the form control matches a passed in regex
   * @param originalString
   * @returns {(control:AbstractControl)=>{[p: string]: any}}
   */
  deleteConfirmationValidator(originalString: string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      const name = (<string>control.value).toLowerCase() === originalString.toLowerCase();
      return name ? null : {'Name of service typed does not match the actual name': {value: control.value}};
    };
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/delete-item-dialog/delete-item-dialog.component.ts